<template>
  <div class="mparEends">
    <div id="allmap" ref="allmap"></div>
    <!-- <div class="info"></div> -->
    <div class="bents">
      <el-button
        size="small"
        :type="index == activeIndex ? 'primary' : ''"
        v-for="(item, index) in btnCunt"
        :key="item.uuid"
        @click="bentClick(index, item.uuid)"
        >{{ lang_file == "en-us" ? item.unittype_en : item.unittype }}</el-button
      >
    </div>
    {{ mapCount }}
  </div>
</template>

<script>
import { getdatamapPost, mapListData } from "@/network/index";
import { mapState } from "vuex";
import MachineRoom_image from "@/assets/img/机放_boos.png";
export default {
  data() {
    return {
      map: null,
      activeIndex: null,
      btnCunt: [],
      sensingunit_uuid: "",
      lang_file: sessionStorage.getItem("lang_file"),
      // point: null,
      // infoWindow: null,
      MachineRoom_image: MachineRoom_image,
    };
  },
  created() {},
  mounted() {
    this.mapListMap();
  },
  computed: {
    ...mapState(["uuidMap"]),
    mapCount() {
      this.mapListMap();
      return console.log(this.$store.state.uuidMap);
    },
  },

  methods: {
    bentClick(index, sensingunit_uuid) {
      this.sensingunit_uuid = sensingunit_uuid;
      this.activeIndex = index;
      this.mapDataInt();
      // this.mapListMap()
    },
    // h获取哦通道
    async mapDataInt() {
      let dataA = {
        gateway_uuid: this.$store.state.uuidMap,
        sensingunit_uuid: this.sensingunit_uuid,
      };
      const { code, data, msg } = await mapListData(dataA);
      //  console.log(data.gatewaylist);
      this.mapTongDao(data.gatewaylist); //获取通道想你想
    },
    // 获取地图信息
    async mapListMap() {
      let dataA = {
        gateway_uuid: this.$store.state.uuidMap,
        sensingunit_uuid: "",
      };
      const { code, data, msg } = await mapListData(dataA);
      console.log(data);
      this.btnCunt = data.sensingunitlist;
      let naaet = data.gatewaylist;
      naaet.forEach((item) => {
        if (item.data != "") {
          item.data.channelinfo.forEach((element) => {
            //获取通到详情
            element.userName = item.name;
          });
        }
      });

      this.mapList(naaet);
    },
    // 没有用
    // async dataRewues() {
    //   // alert('11')
    //   const { code, data, msg } = await getdatamapPost();
    //   // console.log(data);
    //   let naaet = data;
    //   naaet.forEach((item) => {
    //     if (item.data != "") {
    //       item.data.channelinfo.forEach((element) => {
    //         element.userName = item.name;
    //       });
    //     }
    //   });
    // },
    mapList(mapList) {
      this.map = new BMap.Map(this.$refs.allmap);
      this.map.addControl(
        new BMap.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
        })
      );

      // 地图标点
      var info = document.createElement("div");
      var middle = document.createElement("div");
      mapList.forEach((element) => {
        var point = new BMap.Point(element.longitude, element.latitude);
        this.map.centerAndZoom(point, 6);

        var marker = new BMap.Marker(point); // 创建标注

        this.map.addOverlay(marker); // 将标注添加到地图中

        marker.channeldata = element.data.channelinfo;
        marker.addEventListener("click", (e) => {
          // let roles_flag = window.sessionStorage.getItem('username')
          // // 当账号 === c2admin2738 显示 图片
          // if (roles_flag === 'c2admin2738') {
          //   var img = document.createElement("img");
          //   img.style.width =  '100%'
          //   img.style.height =  '97%'
          //   img.src = this.MachineRoom_image
          //   var opts = {
          //        width: 500, // 信息窗口宽度
          //        height: 450, // 信息窗口高度
          //       // title: '信息窗口标题', // 信息窗口标题
          //   };
          //   var infoWindow = new BMap.InfoWindow(img, opts); //创建信息窗口对象
          //   this.map.openInfoWindow(infoWindow, point); //开启信息窗口

          // } else {

          let arr = e.target.channeldata;

          if (arr != undefined) {
            let net = "";
            for (var i = 0; i < arr.length; i++) {
              let it = i + 1;

              let arrs = it * 50;

              var opts = {
                width: 200, // 信息窗口宽度
                height: arrs, // 信息窗口高度
                title: arr[i].userName, // 信息窗口标题
              };

              net += `<ul><li style="color:${
                arr[i].channelflag == 0
                  ? "#00c600"
                  : arr[i].channelflag == 1
                  ? "#0080ff"
                  : "#ff5353"
              }">${
                this.lang_file == "zh-cn" ? arr[i].unittype : arr[i].unittype_en + ":"
              }${arr[i].channeldata}${
                this.lang_file == "zh-cn" ? arr[i].unit : arr[i].unit_en
              }</li> </ul>`;
              info.appendChild(middle);

              var infoWindow = new BMap.InfoWindow(info, opts); //创建信息窗口对象

              this.map.openInfoWindow(infoWindow, point); //开启信息窗口
            }
            middle.innerHTML = net;
          } else {
            this.$message.error("没有数据");
          }
          //  }
        });
      });

      this.map.enableScrollWheelZoom(true); //开启鼠标缩放功能
      let that = this;
      // 定位功能
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          var mk = new BMap.Marker(r.point);
          // that.map.addOverlay(mk);
          that.map.panTo(r.point);
          // alert('您的位置：' + r.point.lng + ',' + r.point.lat)
        } else {
          alert("failed" + this.getStatus() + "定位失败");
        }
      });

      // 地图事件
    },
    //获取通道信息
    mapTongDao(dataList) {
      //  let html =``
      let label;
      // var infob = document.createElement("div");
      // var middlea = document.createElement("div");
      dataList.forEach((item) => {
        var opts = {
          position: new BMap.Point(item.longitude, item.latitude), // 指定文本标注所在的地理位置
          // offset: new BMapGL.Size(30, -30), // 设置文本偏移量
        };
        // 创建文本标注对象

        if (item.channeldata == undefined) {
          item.channeldata = [
            {
              channeldata: "暂无数据",
              unit: "",
            },
          ];
        }
        // console.log(item.channeldata.length>1);

        item.channeldata.forEach((itemEnd) => {
          let html = `
              <div style="width:100%;heigth:50px">
                <div style="padding:0px 0 5px 0">${item.name}</div>
                <div class="textName" style=" text-align: center;font-size: 12px;">${itemEnd.channeldata}${itemEnd.unit}</div>
              </div>
            `;
          // console.log(html);
          label = new BMap.Label(`${html}`, opts);

          // 自定义文本标注样式
          label.setStyle({
            color: "blue",
            borderRadius: "5px",
            borderColor: "#ccc",
            // padding: "10px",
            fontSize: "13px",
            // height: "80px",
            // display:'flex',
            // alignItems: 'center',
            // lineHeight: "80px",
            fontFamily: "微软雅黑",
          });
          this.map.addOverlay(label);
        });
      });
    },
  },
};
</script>

<style scoped>
.mparEends {
  width: 100%;
  height: 800px !important;
  position: relative;
}
#allmap {
  width: 100%;
  height: 100%;
}
.bents {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%);
}
.content-window-card {
  position: relative;
  box-shadow: none;
  bottom: 0;
  left: 0;
  width: auto;
  padding: 0;
}
</style>
